import { useEffect, useState } from "react";
import { fetchHSNData, downloadHSNExcel } from "../Api/ViewHSN";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";

const ViewHSNData = () => {
  const [hsnData, setHsnData] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadHSNData = async () => {
      try {
        const data = await fetchHSNData();
        if (Array.isArray(data)) {
          setHsnData(data);
        } else {
          toast.error("Invalid HSN data format");
        }
      } catch (error) {
        toast.error("Error Fetching HSN Data");
      }
    };
  
    loadHSNData();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadHSNExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'HSN_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("HSN data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  // Format column headers for display
  const formatHeader = (key) => {
    const headerMap = {
      hsnId: "HSN ID",
      code: "Code",
      name: "Name",
      taxType: "Tax Type",
      taxPercentage: "Tax Percentage",
      createdAt: "Created At",
      createdBy: "Created By"
    };
    
    return headerMap[key] || key;
  };

  return (
      <div className="main-content expand">
        <Container fluid className="list-container">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span className="list-title">View HSN Data</span>
            <Button className="generate-btn"
              variant="primary" 
              onClick={handleDownload}
              disabled={isDownloading || hsnData.length === 0}
            >
              {isDownloading ? 'Downloading...' : 'Download Data'}
            </Button>
          </div>

          {hsnData.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      {Object.keys(hsnData[0]).map((key) => (
                        <th key={key}>{formatHeader(key)}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {hsnData.map((hsn, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        {Object.entries(hsn).map(([key, value]) => (
                          <td key={key}>
                            {key === 'createdAt' && typeof value === 'string' 
                              ? new Date(value).toLocaleString() 
                              : value}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No HSN data found.</p>
          )}
        </Container>
      </div>
    
  );
};

export default ViewHSNData;